module.exports = __webpack_public_path__ + "static/media/brinquedo8.0eef9f01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brinquedo8.jpg
// module id = 64
// module chunks = 0